import { render } from "./PageHeader.vue?vue&type=template&id=0c8b8c44"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=0c8b8c44&lang=scss"

import exportComponent from "/codebuild/output/src242043977/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__